import React from 'react';
import PropTypes from 'prop-types';
import './Loading.scss';

export function LoadingApp (props) {
  const { loading } = props;
  return (
    loading && (
      <div className='now-loading'>
        <div className='loading-center'>
          <div className='loading-center-absolute'>
            <div className='object object_one' />
            <div className='object object_two' />
            <div className='object object_three' />
            <div className='object object_four' />
          </div>
        </div>
      </div>
    )
  );
}

LoadingApp.propTypes = {
  loading: PropTypes.bool.isRequired,
};
